import Vue from 'vue';
import Vuex from 'vuex';
import { AbsCatalog } from '@/shared/catalog.model';
import { Project } from '@/shared/project.model';

Vue.use(Vuex)

export interface HelmState {
  name: string;
  title: string;
  thumbnail: string;
  catalogs: Array<AbsCatalog>;
  bannerArticales: Array<Article>;
  accessoryJson: any;
  enterUrl: string;
}

export default new Vuex.Store<HelmState>({
  state: {
    name: '',
    title: '',
    thumbnail: '',
    catalogs: [],
    bannerArticales: [],
    accessoryJson: {},
    enterUrl: '',
  },
  mutations: {
    setAppInfo(state: HelmState, config: Project) {
      console.log('setAppInfo', config);
      state.name = config.name;
      state.title = config.title;
      state.thumbnail = config.thumbnail;
      while (state.catalogs.length > 0) {
        state.catalogs.shift();
      }
      config.catalogs.forEach(c => state.catalogs.push(c));
      state.accessoryJson = config['accessoryJson'] as any;
    },
    setBannerArticales(state: HelmState, payload: any) {
      const { index, articles } = payload;
      if (state.bannerArticales.length === 0) {
        state.bannerArticales.push(articles);
      } else {
        if (index === 0) {
          state.bannerArticales.unshift(articles);
        } else {
          state.bannerArticales.push(articles);
        }
      }     
    },
    setEnterUrl(state: HelmState, url: string) {
      console.log('enterUrl', url);
      state.enterUrl = url;
    }
  },
  getters: {
    name: state => state.name,
    title: state => state.title,
    thumbnail: state => state.thumbnail,
    catalogs: state => state.catalogs,
    accessoryJson: state => state.accessoryJson,
    bannerCount: state => state.bannerArticales.length,
    bannerArticlesByIndex: (state) => (index: number) => {
      return state.bannerArticales.length > index ? state.bannerArticales[index] : []
    },
    enterUrl: state => state.enterUrl,
  }
});
